import type { Instrument } from '@thinkalpha/common/schemas/instruments.js';

/**
 * Generic legacy table-row linking action. Results publishes through
 * WorkspaceService directly; the remaining Redux-backed widgets use this
 * compatibility action until their own ADR 0012 cutovers.
 */
export type UserDoubleClickedSymbolFromTableAction = {
    type: 'userDoubleClickedSymbolFromTable';
    symbol: string;
    tabId: string;
};

export const userDoubleClickedSymbolFromTable = (
    tabId: string,
    symbol: string,
): UserDoubleClickedSymbolFromTableAction => ({
    symbol,
    tabId,
    type: 'userDoubleClickedSymbolFromTable',
});

export type SymbolLinkingActions = UserDoubleClickedSymbolFromTableAction;

export type WorkspaceLinkingInstrumentSelectedAction = {
    type: 'workspaceLinkingInstrumentSelected';
    tabId: string;
    instrument: Instrument;
};

export const workspaceLinkingInstrumentSelected = (
    tabId: string,
    instrument: Instrument,
): WorkspaceLinkingInstrumentSelectedAction => ({
    type: 'workspaceLinkingInstrumentSelected',
    tabId,
    instrument,
});

export type WorkspaceLinkingAccountSelectedAction = {
    type: 'workspaceLinkingAccountSelected';
    tabId: string;
    accountId: string;
};

export const workspaceLinkingAccountSelected = (
    tabId: string,
    accountId: string,
): WorkspaceLinkingAccountSelectedAction => ({
    type: 'workspaceLinkingAccountSelected',
    tabId,
    accountId,
});

export type WorkspaceLinkingQuantitySelectedAction = {
    type: 'workspaceLinkingQuantitySelected';
    tabId: string;
    quantity: number;
};

export const workspaceLinkingQuantitySelected = (
    tabId: string,
    quantity: number,
): WorkspaceLinkingQuantitySelectedAction => ({
    type: 'workspaceLinkingQuantitySelected',
    tabId,
    quantity,
});

export type WorkspaceLinkingOrderSelectedAction = {
    type: 'workspaceLinkingOrderSelected';
    tabId: string;
    orderId: string;
    instrument?: string;
};

export const workspaceLinkingOrderSelected = (
    tabId: string,
    orderId: string,
    instrument?: string,
): WorkspaceLinkingOrderSelectedAction => ({
    type: 'workspaceLinkingOrderSelected',
    tabId,
    orderId,
    instrument,
});

export type WorkspaceLinkingActions =
    | WorkspaceLinkingInstrumentSelectedAction
    | WorkspaceLinkingAccountSelectedAction
    | WorkspaceLinkingQuantitySelectedAction
    | WorkspaceLinkingOrderSelectedAction;
